export function segmentArray(array: any[], segmentCount: number) {
  const segmentSize = Math.ceil(array.length / segmentCount)
  const segments = []

  while (array.length) {
    segments.push(array.splice(0, segmentSize))
  }

  return segments
}
